import React, { useState, useEffect } from 'react';
import { InputWrapper, InputStyled } from './Styled';
import { inputValidate } from '../../../helpers';

interface InputProps {
  name: string;
  label: string;
  value: string;
  placeholder?: string;
  feedback?: string;
  required?: boolean;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  validate?: 'reviewText' | 'reviewTitle' | 'troubleDescription';
  maxLength?: number;
}

const Input = (props: InputProps) => {
  const { validate, placeholder, onBlur, required, label, name, value, feedback, onChange, maxLength = 100 } = props;
  const [valid, setValid] = useState(false);
  const classInput = validate && value.length ? (valid ? 'valid' : 'invalid') : '';
  const classLabel = required ? `required ${classInput}` : '';
  const info = value.length ? `${value.length} caracteres (${feedback})` : `${feedback}`;

  useEffect(() => {
    if (validate) {
      const status = inputValidate({ key: validate, text: value });
      setValid(status);
    }
  }, [value]);

  return (
    <InputWrapper>
      <InputStyled>
        <input
          autoComplete="off"
          type="text"
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          onBlur={onBlur}
          className={classInput}
          maxLength={maxLength}
        />
        <label className={classLabel}>{label}</label>
      </InputStyled>
      <span>{info}</span>
    </InputWrapper>
  );
};

Input.defaultProps = {
  name: '',
  value: '',
  label: '',
  placeholder: '',
  feedback: '',
  required: false,
};

export default Input;
export { Input };
